import type { VoteOption } from "@afas-doe-maar/models";

export const voteOptionLabels: Record<VoteOption, string> = {
  green: "groen",
  pink: "roze",
};
